export const usernameRegex = /^[a-zA-Z0-9+.+-_]+$/;

export const emailRegex = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;

export const passwordRegex = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/;